// extracted by mini-css-extract-plugin
export default {"container":"NoTenant_container__TQid4","desc":"NoTenant_desc__npN70"};